import type { CustomIconProps } from '../CustomIcon';

export const CheckStroke = ({
  color,
  secondaryColor,
  ternaryColor,
  size = 24,
  solid,
  ...props
}: CustomIconProps) => (
  <svg
    width={size}
    height={size}
    fill='none'
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='M20 6L9 17L4 12'
      stroke={color || '#231F1C'}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
